var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.items.length > 0
    ? _c("div", { staticClass: "bg-light-grey m-t-3 crossGarantie" }, [
        _c("div", { staticClass: "widget-inner" }, [
          _c("div", { staticClass: "sub-headline mb-4" }, [
            _vm._v(
              "\n            " +
                _vm._s(
                  _vm.$translate("Servershop5::Template.garantieempfehlung")
                ) +
                "\n        "
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              ref: "hidding",
              staticClass: "hide-more-items",
              attrs: { id: "hidden_" + this._uid + 10 },
            },
            [
              _c(
                "ul",
                { staticClass: "product-list row grid categoryItem" },
                [
                  _vm._l(_vm.items, function (item) {
                    return [
                      _c(
                        "li",
                        { staticClass: "col-12 col-sm-6 col-md-4 col-lg-3" },
                        [
                          _c("category-item", {
                            attrs: {
                              "item-data": item.data,
                              "decimal-count": 2,
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  }),
                ],
                2
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "button",
            { staticClass: "showMore btn btn-dark-blue mx-auto d-flex mt-3" },
            [
              _c("span", [
                _vm._v(
                  "\n                " +
                    _vm._s(
                      _vm.$translate(
                        "Servershop5::Template.ShowMoreItemsOfGarantie"
                      )
                    ) +
                    "\n            "
                ),
              ]),
              _vm._v(" "),
              _c("span", [
                _vm._v(
                  "\n                " +
                    _vm._s(
                      _vm.$translate(
                        "Servershop5::Template.ShowLessItemsOfGarantie"
                      )
                    ) +
                    "\n            "
                ),
              ]),
            ]
          ),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }